import styled from 'styled-components';

export const Container = styled.form`
    display: flex;
    /* flex: auto 0 1; */
    height: 100%;
    width: 100%;
    overflow-x: hidden;
    overflow-y: auto;
    padding: 15px;
    flex-direction: column;
`;

export const Title = styled.h1`
    text-align: center;

`;

export const Disclaimer = styled.h2`
    text-align: center;
    color: var(--dark);
    font-weight: 500;
    font-size: 18px;
`;

export const ContainerEtapa = styled.div`
    display: flex;
    flex: auto 0 1;
    flex-direction: column;
    justify-content:center;
    margin: 10px 0px;

    > h3 {
        margin-bottom: 5px;
    }
`;

export const ContainerOpcoesClicaveis = styled.div`
    display: flex;
    flex: auto 0 1;
    flex-direction: row;
    flex-wrap:wrap;

`;

export const OpcaoClicavel = styled.label`
    display: flex;
    min-width: 70px;
    height: 32px;
    position: relative;
    flex: auto 0 1;
    position: relative;
    cursor: pointer;
    font-size: 16px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    transition-duration: .3s;

    :hover > span {
        background-color: var(--primaryColorHover);
    }

    :active{
        transform:scale(.9)
    }

    > input {
        position: absolute;
        opacity: 0;
        cursor: pointer;
        height: 0;
        width: 0;
    }

    > span {
        background-color: var(--primaryColor);
        color: #fff;
        position: absolute;
        top: 0;
        left: 0;
        border-radius: 5px;
        padding: 5px 5px;
    }

    > input:checked ~ span {
        background-color: var(--successColor);
    }
`;

export const ContainerFicha = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 15px;
`;
export const ItemFicha = styled.div`
    display: flex;
    flex: auto 0 1;
    flex-direction: column;
    justify-content:center;
    /* align-items:center; */
`;
